// Analytics Redux Slice

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { analyticsApi } from '../../api/analyticsApi';

// ─── Async Thunk ───────────────────────────────────────────────────────────────

export const fetchAnalytics = createAsyncThunk(
  'analytics/fetch',
  async (period, { rejectWithValue }) => {
    try {
      const res = await analyticsApi.getSalesAnalytics(period);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load analytics');
    }
  }
);

// ─── Slice ────────────────────────────────────────────────────────────────────

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    data: null,
    loading: false,
    error: null,
    period: 'today',
  },
  reducers: {
    setPeriod: (state, { payload }) => {
      state.period = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending,   (state) => { state.loading = true;  state.error = null; })
      .addCase(fetchAnalytics.fulfilled, (state, { payload }) => { state.loading = false; state.data = payload; })
      .addCase(fetchAnalytics.rejected,  (state, { payload }) => { state.loading = false; state.error = payload; });
  },
});

export const { setPeriod } = analyticsSlice.actions;
export default analyticsSlice.reducer;
